module.exports = __webpack_public_path__ + "img/design.8aeaab8.webp";